<template>
    <div class="mt-5" v-if="scoredStudents.length">
        <div class="md:flex space-x-2">
            <div class="md:grid md:grid-cols-3 md:gap-6">
                <div>
                    <BadgePill :color="minScorePill.color">
                        {{ $t('messages.min_grade') }}: {{ minScorePill.decimal_score }}
                    </BadgePill>
                </div>
                <div>
                    <BadgePill :color="topScorePill.color">
                        {{ $t('messages.top_grade') }}: {{ topScorePill.decimal_score }}
                    </BadgePill>
                </div>
                <div>
                    <BadgePill :color="averageScorePill.color">
                        {{ $t('messages.avg_grade') }}: {{ averageScorePill.decimal_score }}
                    </BadgePill>
                </div>
            </div>
            <BadgePill color="gray"> {{ $t('messages.activity_absent') }}: {{ missed }} </BadgePill>
            <BadgePill color="gray"> {{ $t('messages.activity_passed') }}: {{ passed }} </BadgePill>
            <BadgePill color="gray"> {{ $t('messages.activity_failed') }}: {{ failed }} </BadgePill>
        </div>
        <div class="flex space-x-2">
            <BadgePill color="gray" v-for="counter in counters" :key="`${counter.key}_${counter.value}`">
                {{ counter.key }}: {{ counter.value }}
            </BadgePill>
        </div>
    </div>
</template>

<script>
import GradeTranslator from '@/classes/GradeTranslator.js';
import BadgePill from '@/components/BadgePill.vue';

export default {
    name: 'ActivityGradesSummary',
    props: {
        values: {
            type: Array,
            required: false,
            default: () => [],
        },
        ranges: {
            type: Array,
            required: true,
        },
    },
    components: {
        BadgePill,
    },
    data: function () {
        return {
            gradeTranslator: new GradeTranslator(this.ranges),
        };
    },
    computed: {
        counters: function () {
            if (this.gradeTranslator === undefined) {
                return [];
            }

            const counters = this.gradeTranslator.getCounterMap();

            this.scoredStudents.forEach((s) => {
                let key = this.gradeTranslator.scoreToLetter(s);
                if (key) {
                    let index = counters.findIndex((c) => c.key === key);
                    counters[index].value++;
                }
            });

            return counters;
        },
        scoredStudents: function () {
            return this.values.filter((s) => s !== null);
        },
        missed: function () {
            return this.values.filter((s) => s === null).length;
        },
        passed: function () {
            return this.scoredStudents.filter((s) => s >= 5).length;
        },
        failed: function () {
            return this.scoredStudents.filter((s) => s < 5).length;
        },
        averageScorePill: function () {
            const total = this.scoredStudents.reduce((a, b) => a + b);
            const average = total / this.scoredStudents.length;
            return this.gradeTranslator.scoreToPill(average);
        },
        minScorePill: function () {
            let minScore = Math.min(...this.scoredStudents);
            return this.gradeTranslator.scoreToPill(minScore);
        },
        topScorePill: function () {
            const topScore = Math.max(...this.scoredStudents);
            return this.gradeTranslator.scoreToPill(topScore);
        },
    },
};
</script>
